import "./style.css";

export default class ImportantMessageBanner {
  static selector = ".important-message-banner";

  constructor(block) {
    this.block = block;
    this.id = block.dataset.messageId || "generic";

    this.closeButton = this.block.querySelector(
      ".important-message-banner__close"
    );
  }

  setCookie(cname, cvalue, exdays = 30) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie =
      "important-message--" + cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  handleClose = () => {
    this.setCookie(this.id, "done");
    this.block.classList.add("important-message-banner--closed");
  };

  onReady = () => {
    if (this.closeButton) {
      this.closeButton.addEventListener("click", this.handleClose);
    }
  };
  onDestroy = () => {
    if (this.closeButton) {
      this.closeButton.removeEventListener("click", this.handleClose);
    }
  };
}
